import { render, staticRenderFns } from "./TherapyMain.vue?vue&type=template&id=7e0a731b&lang=true&"
import script from "./TherapyMain.vue?vue&type=script&lang=js&"
export * from "./TherapyMain.vue?vue&type=script&lang=js&"
import style0 from "./TherapyMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports